import { useConfig } from 'config';
import { FeatureFlag, getFeatureFlag } from 'constants/feature-flag';
import { useIsExistingCustomer } from 'hooks/common/use-is-existing-customer';
import useDynamicTest from 'hooks/test/use-dynamic-ux';
import { DynamicTestScenario } from 'hooks/test/use-dynamic-ux/const';

/**
 * Hook to check if the user is an existing customer and show the EC pet profile
 */
const useEcPetProfile = () => {
  const { shopId } = useConfig();
  const isEcPetProfileEnabled = getFeatureFlag(
    FeatureFlag.ecPetProfile,
    shopId
  );
  // We don't check explicitly if the user is applied to DUX here because DUX condition should exclude them
  const { isEc, loading } = useIsExistingCustomer();
  const { loading: duxLoading, testScenario } = useDynamicTest();

  return {
    isLoading: loading || duxLoading,
    shouldShowEcPetProfile:
      isEcPetProfileEnabled &&
      isEc &&
      testScenario === DynamicTestScenario.control,
  };
};

export default useEcPetProfile;
